import React from 'react';

import MessagePlaceholder from './message.placeholder';

const Placeholder = props => {
    return (
        <div className="discussion placeholder">
            <div className="discussion-body">
                <div className="discussion-scrollable">
                    <div className="discussion-scrollable-inner">
                        <MessagePlaceholder key={0} animate={!props.static} />

                        <MessagePlaceholder key={1} animate={!props.static} />

                        <MessagePlaceholder key={2} animate={!props.static} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Placeholder;
